<section class="dashboard">

  <div class="lx-page-header" style="border-bottom: none; margin-bottom: 24px; padding-bottom: 0;">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.dashboard_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.dashboard_title' | translate }}</h2>
      <p class="lx-page-subtitle">{{ 'page.dashboard_subtitle' | translate }}</p>
    </div>
  </div>

  <ng-container *ngIf="loading">
    <div class="kpi-row">
      <div class="skel skel-kpi" *ngFor="let i of skeletonCards"></div>
    </div>
    <div class="charts-row">
      <div class="skel skel-chart"></div>
      <div class="skel skel-chart"></div>
    </div>
    <div class="skel skel-monthly"></div>
    <div class="metric-row">
      <div class="skel skel-metric" *ngFor="let i of skeletonCards"></div>
      <div class="skel skel-metric"></div>
      <div class="skel skel-metric"></div>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && stats">

    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-icon kpi-icon--blue">
          <span class="material-symbols-outlined">group</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">{{ 'kpi.total_clients' | translate }}</span>
          <p class="kpi-value">{{ stats.total_clients | number }}</p>
        </div>
      </div>

      <div class="kpi-card" *ngIf="isSuperAdmin">
        <div class="kpi-icon kpi-icon--indigo">
          <span class="material-symbols-outlined">payments</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">{{ 'kpi.total_revenue' | translate }}</span>
          <p class="kpi-value">{{ stats.total_revenue | number:'1.0-0' }} <small>EGP</small></p>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon kpi-icon--green">
          <span class="material-symbols-outlined">shopping_bag</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">{{ 'kpi.total_orders' | translate }}</span>
          <p class="kpi-value">{{ stats.total_orders | number }}</p>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon kpi-icon--orange">
          <span class="material-symbols-outlined">pending</span>
        </div>
        <div class="kpi-body">
          <span class="kpi-label">{{ 'kpi.pending_orders' | translate }}</span>
          <p class="kpi-value">{{ stats.pending_orders | number }}</p>
        </div>
      </div>
    </div>

    <div class="charts-row">

      <div class="chart-card">
        <div class="chart-card-header">
          <span class="material-symbols-outlined">donut_large</span>
          <h3 class="chart-card-title">{{ 'kpi.order_status' | translate }}</h3>
        </div>
        <div class="donut-wrap">
          <div class="donut-canvas-wrap">
            <canvas #orderChart></canvas>
            <div class="donut-center">
              <p class="donut-total">{{ stats.total_orders | number }}</p>
              <span class="donut-sub">{{ 'kpi.total' | translate }}</span>
            </div>
          </div>
          <div class="donut-legend">
            <div class="legend-item">
              <span class="legend-dot" style="background:#FBBF24"></span>
              <span class="legend-name">{{ 'status.pending' | translate }}</span>
              <span class="legend-val">{{ stats.pending_orders }}</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" style="background:#34D399"></span>
              <span class="legend-name">{{ 'status.delivered' | translate }}</span>
              <span class="legend-val">{{ stats.delivered_orders }}</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" style="background:#FB7185"></span>
              <span class="legend-name">{{ 'nav.cancelled' | translate }}</span>
              <span class="legend-val">{{ stats.cancelled_orders }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-card">
        <div class="chart-card-header">
          <span class="material-symbols-outlined">bar_chart</span>
          <h3 class="chart-card-title">{{ 'kpi.content_inventory' | translate }}</h3>
        </div>
        <div class="bar-wrap" *ngIf="hasInventoryData; else emptyInventory">
          <canvas #inventoryChart></canvas>
        </div>
        <ng-template #emptyInventory>
          <div class="chart-empty">
            <span class="material-symbols-outlined">inventory_2</span>
            <p>{{ 'kpi.no_inventory' | translate }}</p>
          </div>
        </ng-template>
      </div>

    </div>

    <div class="chart-card monthly-chart-card" *ngIf="!monthlyLoading && monthlyStats.length > 0">
      <div class="chart-card-header">
        <span class="material-symbols-outlined">show_chart</span>
        <h3 class="chart-card-title">{{ 'kpi.orders_per_month' | translate }}</h3>
        <span class="monthly-badge">
          {{ totalMonthlyOrders | number }} {{ 'kpi.orders_unit' | translate }} · {{ 'kpi.last_12_months' | translate }}
        </span>
      </div>
      <div class="monthly-wrap">
        <canvas #monthlyChart></canvas>
      </div>
    </div>

    <div class="chart-card monthly-chart-card" *ngIf="!monthlyLoading && monthlyStats.length === 0">
      <div class="chart-card-header">
        <span class="material-symbols-outlined">show_chart</span>
        <h3 class="chart-card-title">{{ 'kpi.orders_per_month' | translate }}</h3>
      </div>
      <div class="chart-empty">
        <span class="material-symbols-outlined">bar_chart</span>
        <p>{{ 'kpi.no_monthly_orders' | translate }}</p>
      </div>
    </div>

    <div class="skel skel-monthly" *ngIf="monthlyLoading && !loading"></div>

    <div class="metric-row">
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#818CF8">inventory_2</span>
        <div>
          <p class="metric-value">{{ stats.total_products }}</p>
          <span class="metric-label">{{ 'kpi.products' | translate }}</span>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#FBBF24">category</span>
        <div>
          <p class="metric-value">{{ stats.total_categories }}</p>
          <span class="metric-label">{{ 'kpi.categories' | translate }}</span>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#EC4899">package_2</span>
        <div>
          <p class="metric-value">{{ stats.total_packages }}</p>
          <span class="metric-label">{{ 'kpi.packages' | translate }}</span>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#38BDF8">article</span>
        <div>
          <p class="metric-value">{{ stats.total_blogs }}</p>
          <span class="metric-label">{{ 'kpi.blogs' | translate }}</span>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#34D399">local_shipping</span>
        <div>
          <p class="metric-value">{{ stats.delivered_orders }}</p>
          <span class="metric-label">{{ 'status.delivered' | translate }}</span>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-symbols-outlined metric-icon" style="color:#FB7185">cancel</span>
        <div>
          <p class="metric-value">{{ stats.cancelled_orders }}</p>
          <span class="metric-label">{{ 'nav.cancelled' | translate }}</span>
        </div>
      </div>
    </div>

  </ng-container>

</section>
